import { StyleSheet } from 'react-native';
import Font from './Font';

const baseStyle = {
  fontFamily: 'Inter',
  letterSpacing: -0.05,
};

export const globalFontStyle = StyleSheet.create({
  appFontMainHead: {
    ...baseStyle,
    fontSize: Font.fontSize28,
    fontWeight: '600',
  },
  appBlueHead: {
    ...baseStyle,
    fontSize: Font.fontSize26,
    fontWeight: '700',
  },
  appFontTitleHead: {
    ...baseStyle,
    fontSize: Font.fontSize32,
    fontWeight: '600',
  },
  appFontTitle: {
    ...baseStyle,
    fontSize: Font.fontSize22,
    fontWeight: '600',
  },
  appFontTitleRegular: {
    ...baseStyle,
    fontSize: Font.fontSize22,
    fontWeight: '400',
  },
  appFontEventTitle: {
    ...baseStyle,
    fontSize: Font.fontSize20,
    fontWeight: '600',
  },
  appFontHeading: {
    ...baseStyle,
    fontSize: Font.fontSize18,
    lineHeight: 24,
    fontWeight: '600',
  },
  appFontHeadingSubtitle: {
    ...baseStyle,
    fontSize: Font.fontSize18,
    lineHeight: 24,
    fontWeight: '400',
    opacity: 0.7,
  },
  appFontHeadingRegular: {
    ...baseStyle,
    fontSize: Font.fontSize18,
    lineHeight: 24,
    fontWeight: '400',
  },
  appFontSubHeading: {
    ...baseStyle,
    fontSize: Font.fontSize16,
    fontWeight: '400',
  },
  appFontBody: {
    ...baseStyle,
    fontSize: Font.fontSize16,
    fontWeight: '400',
  },
  appFontSubTextBold: {
    ...baseStyle,
    fontSize: Font.fontSize14,
    fontWeight: '600',
  },
  appFontSubText: {
    ...baseStyle,
    fontSize: Font.fontSize14,
    fontWeight: '400',
  },
  appFontSubTextWeight: {
    ...baseStyle,
    fontSize: Font.fontSize14,
    fontWeight: '600',
  },
  appFontSmallText: {
    ...baseStyle,
    fontSize: Font.fontSize12,
    fontWeight: '400',
  },
  appFontSmallTextBold: {
    ...baseStyle,
    fontSize: Font.fontSize12,
    fontWeight: '600',
  },
  appFontSmallTextWeight: {
    ...baseStyle,
    fontSize: Font.fontSize12,
    fontWeight: '600',
  },
  appFontSmallText10: {
    ...baseStyle,
    fontSize: Font.fontSize10,
    fontWeight: '400',
  },
  appSmall10: {
    ...baseStyle,
    fontSize: Font.fontSize10,
    fontWeight: '400',
  },
  appSmall10Bold: {
    ...baseStyle,
    fontSize: Font.fontSize10,
    fontWeight: '600',
  },
  appSmall8: {
    ...baseStyle,
    fontSize: Font.fontSize8,
    fontWeight: '400',
  },
});
